import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import {
  Footer,
  Wearable,
  MainContainer,
  HeroContainer,
  InnerContainer,
  InfoContainer,
  BannerContainer,
  MessageContainer,
  AppStoreLinks
} from "./styles";

import copyToClipboard from "../../assets/copy-icon.svg";
import linkedinLogo from "../../assets/linkedin.svg";
import twitterLogo from "../../assets/twitter.svg";
import facebookLogo from "../../assets/facebook.svg";
import fingernailImage from "./img/fingernail.webp";
import oktobertech25banner from "./img/banner.webp";
import appStoreLogo from "../../assets/app-store.svg";
import gplayLogo from "../../assets/play-store.svg";

import packageJson from "../../../package.json";

const Oktobertech25 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  const appStoreLinks = (appStoreUrl, playStoreUrl) => {
    return (
      <AppStoreLinks>
        <img
          src={appStoreLogo}
          alt="app-store"
          onClick={() => window.open(appStoreUrl, "_blank")}
        />
        <img
          src={gplayLogo}
          alt="play-store"
          onClick={() => window.open(playStoreUrl, "_blank")}
        />
      </AppStoreLinks>
    );
  };

  return (
    <MainContainer>
      <BannerContainer
        onClick={() =>
          window.open(
            "https://app.jingsocial.com/mF/websiteEditorLandingPage/page/1f5a8b11b30b44d89df0606eee14b5ab?pushId=myUT7zqNtr5L7ssYdhjbqC1",
            "_blank"
          )
        }
      >
        <img src={oktobertech25banner} alt="oktobertech25" />
      </BannerContainer>
      <MessageContainer>点击图片进入大会官方网页，了解更多！</MessageContainer>

      <Wearable className="wearable">
        <img src={fingernailImage} alt="wearable" />
      </Wearable>

      <InnerContainer>
        <HeroContainer>
          <p>
            恭喜您成为由英飞凌、Smart Chip和 DIGISEQ 提供支持的全球首款
            NFC智能指甲的佩戴者。立即体验这款新颖的支付方式！
          </p>
        </HeroContainer>
        <InfoContainer>
          <h2>Visit Infineon</h2>
          <p>访问英飞凌官网，了解更多支付解决方案</p>
          <a
            href="https://www.infineon.com/cms/cn/applications/security-solutions/payment-solutions/?utm_campaign=ci19810001_202504_gc_cn_cp.e.electronica&utm_medium=socialmediaorganic&utm_source=wechat_textpost&utm_content=_&utm_term="
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </a>
        </InfoContainer>
        <InfoContainer>
          <h2>关于Smart Chip</h2>
          <p>
            在DIGISEQ的支持下，Smart Chip
            公司于2024年开发并推出了世界上第一款带有 RFID 芯片的 NFC
            美甲套餐。有了这款指尖智能芯片，您就可以随时随地享受丝滑的支付体验。
          </p>
          <a href="https://smart-chip.com/" target="_blank" rel="noreferrer">
            Learn more
          </a>
        </InfoContainer>
        <InfoContainer>
          <h2>
            Who are <span className="emphasized">DIGISEQ?</span>
          </h2>
          <p>
            DIGISEQ
            是一个屡获殊荣的物联网服务平台，可为日常可穿戴设备提供安全可靠的数据，使从戒指到服装的各种物品都能提供
            NFC 支付、客户参与功能、访问控制和数字身份。
          </p>
          <a href="https://www.digiseq.co.uk" target="_blank" rel="noreferrer">
            Learn more
          </a>
        </InfoContainer>
        <InfoContainer>
          <h2>Manage-Mii app</h2>
          <p>Manage your business card with Manage-Mii</p>
          {appStoreLinks(
            "https://apps.apple.com/app/manage-mii/id6446908503",
            "https://play.google.com/store/apps/details?id=com.digiseq.managemii"
          )}
        </InfoContainer>
      </InnerContainer>

      <Footer>
        <div>
          <h2 className="emphasized">DIGISEQ</h2>
          <h2>Revolutionising the Way We Pay.</h2>
        </div>
        <ul className="links">
          <li>
            <a
              href="https://www.digiseq.co.uk"
              target="_blank"
              rel="noreferrer"
            >
              <p>Our Website</p>
            </a>
          </li>

          <li>
            <a
              href="https://digiseq.co.uk/terms-conditions/"
              target="_blank"
              rel="noreferrer"
            >
              <p>Terms and Conditions</p>
            </a>
          </li>
          <li>
            <a
              href="https://www.digiseq.co.uk/wearables-and-psd2-sca"
              target="_blank"
              rel="noreferrer"
            >
              <p>Wearables and PSD2 SCA</p>
            </a>
          </li>
        </ul>
        <ul className="socials">
          <li>
            <a
              href="https://www.linkedin.com/company/digiseq"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedinLogo} alt="linkedin logo" />
            </a>
          </li>
          <li>
            <a href="https://x.com/digisequk" target="_blank" rel="noreferrer">
              <img src={twitterLogo} alt="twitter logo" />
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/Digiseq/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={facebookLogo} alt="facebook logo" />
            </a>
          </li>
        </ul>
        <div className="copyToClipboard">
          <img
            onClick={() => {
              navigator.clipboard.writeText(serialNumber);
              setCopied(true);
            }}
            src={copyToClipboard}
            alt="copy to clipboard"
          />
          <p>ID: {serialNumber}</p>
        </div>
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </Footer>
    </MainContainer>
  );
};

export default Oktobertech25;
